/* Sijl Buy Box - gedeelde JS voor de product-sections Koffie en Overig.
   Configuratie komt per section binnen via een <script data-sijl-buybox-config> JSON-blok. */
(function () {
  'use strict';

  var cfgEl = document.querySelector('[data-sijl-buybox-config]');
  if (!cfgEl) return;

  var CONFIG;
  try {
    CONFIG = JSON.parse(cfgEl.textContent);
  } catch (error) {
    return;
  }

  var PRODUCT_VARIANTS = CONFIG.variants || [];
  var HAS_MULTIPLE_VARIANTS = PRODUCT_VARIANTS.length > 1;
  var ANY_VARIANT_AVAILABLE = PRODUCT_VARIANTS.some(function (variant) { return variant.available; });
  var INITIAL_VARIANT_ID = CONFIG.initialVariantId;
  var CURRENCY = CONFIG.currency || 'EUR';
  var SHIPPING_MODE = CONFIG.shippingMode || 'business';
  var SHIPPING_DAYS_SETTING = CONFIG.shippingDays || '3,5';
  var MONTHLY_COFFEE_AVERAGE = Number(CONFIG.coffeeMonthlyAverage) || 0;
  // Koffie met de tag 'binnenkort': de sectie toont geen prijs en geen keuze, de knop blijft uit.
  var BINNENKORT = CONFIG.binnenkort === true;

  var $ = function (selector) { return document.querySelector(selector); };
  var $$ = function (selector) { return Array.prototype.slice.call(document.querySelectorAll(selector)); };

  var currentVariant = PRODUCT_VARIANTS.filter(function (variant) {
    return String(variant.id) === String(INITIAL_VARIANT_ID);
  })[0] || PRODUCT_VARIANTS[0];

  var moneyFormatter;
  try {
    /* Zelfde notatie als Liquid: €13,00, zonder spatie na het euroteken (stap 48). */
    moneyFormatter = (function () {
      var munt = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: CURRENCY });
      var getal = new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return { format: function (bedrag) { return CURRENCY === 'EUR' ? '€' + getal.format(bedrag) : munt.format(bedrag); } };
    })();
  } catch (error) {
    moneyFormatter = {
      format: function (value) { return '€' + Number(value).toFixed(2).replace('.', ','); }
    };
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function formatMoney(cents) {
    return moneyFormatter.format((Number(cents) || 0) / 100);
  }

  function getCurrentQuantity() {
    var quantityInput = $('#sijl-quantity-input');
    var min = quantityInput ? Number(quantityInput.min) || 1 : 1;
    var value = quantityInput ? parseInt(quantityInput.value, 10) : min;
    return Math.max(value || min, min);
  }

  function getRoute(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function setDisabled(button, disabled) {
    if (!button) return;
    button.disabled = disabled;
    button.setAttribute('aria-disabled', String(disabled));
  }

  function findVariantById(id) {
    return PRODUCT_VARIANTS.filter(function (variant) {
      return String(variant.id) === String(id);
    })[0];
  }

  function renderAtcButton(variant) {
    var atcButton = $('#sijl-main-atc');
    if (!atcButton || !variant) return;

    var quantity = getCurrentQuantity();
    var totalPrice = (Number(variant.price) || 0) * quantity;

    atcButton.classList.remove('is-loading', 'has-error');

    if (BINNENKORT) {
      atcButton.textContent = 'Binnenkort beschikbaar';
      setDisabled(atcButton, true);
      return;
    }

    if (!variant.available) {
      // De variant erbij noemen heeft alleen zin als een andere variant nog wel leverbaar is.
      atcButton.textContent = HAS_MULTIPLE_VARIANTS && ANY_VARIANT_AVAILABLE
        ? 'Uitverkocht (' + variant.title + ')'
        : 'Uitverkocht';
      setDisabled(atcButton, true);
      return;
    }

    setDisabled(atcButton, false);

    // De gekozen variant staat er direct boven; hier blijft hij onzichtbaar staan voor
    // schermlezers en voor de vaste bestelbalk op de telefoon, die hem hieruit leest.
    atcButton.innerHTML = HAS_MULTIPLE_VARIANTS
      ? 'In winkelwagen \u00b7 <span id="sijl-main-atc-price"></span> <span id="sijl-main-atc-variant" class="sijl-visually-hidden"></span>'
      : 'In winkelwagen \u00b7 <span id="sijl-main-atc-price"></span>';

    var atcPrice = $('#sijl-main-atc-price');
    var atcVariant = $('#sijl-main-atc-variant');

    if (atcPrice) atcPrice.textContent = formatMoney(totalPrice);
    if (atcVariant) atcVariant.textContent = variant.title;
  }

  /* De sectie zet bedragen neer in de notatie van de winkel; hier krijgen ze dezelfde
     notatie als de prijs en de koopknop, zodat er niet twee schrijfwijzen door elkaar staan. */
  function formatStaticPrices() {
    $$('[data-sijl-cents]').forEach(function (el) {
      el.textContent = formatMoney(el.dataset.sijlCents);
    });
  }

  /* Prijs per kilo naast de prijs. De sectie rekent hem per variant uit en zet hem op de
     keuzeknop (data-unit-cents). Bij een zak van precies een kilo is hij gelijk aan de prijs
     en blijft de regel leeg. */
  function renderUnitPrice(variant) {
    var unitDisplay = $('#sijl-unit-price-display');
    if (!unitDisplay) return;

    var label = document.querySelector('.sijl-weight-option[data-id="' + variant.id + '"]');
    var unitCents = label ? Number(label.dataset.unitCents) || 0 : 0;

    unitDisplay.textContent = unitCents && unitCents !== Number(variant.price)
      ? formatMoney(unitCents) + ' per kg'
      : '';
  }

  function syncVariantState(variant) {
    if (!variant) return;

    currentVariant = variant;

    var hiddenVariantInput = $('#sijl-main-variant-input');
    var priceDisplay = $('#sijl-price-display');

    if (hiddenVariantInput) hiddenVariantInput.value = variant.id;
    if (priceDisplay) priceDisplay.textContent = formatMoney(variant.price);
    renderUnitPrice(variant);

    $$('.sijl-weight-option, .sijl-option').forEach(function (label) {
      label.classList.toggle('active', String(label.dataset.id) === String(variant.id));
    });

    var radio = document.querySelector('.sijl-variant-radio[value="' + variant.id + '"]');
    if (radio && !radio.disabled) radio.checked = true;

    renderAtcButton(variant);
  }

  function setupVariantSelector() {
    $$('.sijl-variant-radio').forEach(function (radio) {
      radio.addEventListener('change', function () {
        syncVariantState(findVariantById(radio.value));
      });
    });

    document.addEventListener('variant:change', function (event) {
      var variant = event.detail && (event.detail.variant || event.detail);
      syncVariantState(variant);
    });
  }

  function setupQuantitySelector() {
    var quantityInput = $('#sijl-quantity-input');
    var minusBtn = $('[data-sijl-qty-minus]');
    var plusBtn = $('[data-sijl-qty-plus]');

    if (!quantityInput) return;

    function normalizeQuantity() {
      var min = Number(quantityInput.min) || 1;
      var value = Math.max(parseInt(quantityInput.value, 10) || min, min);
      quantityInput.value = value;
      renderAtcButton(currentVariant);
      return value;
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        quantityInput.value = Math.max((parseInt(quantityInput.value, 10) || 1) - 1, Number(quantityInput.min) || 1);
        normalizeQuantity();
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        quantityInput.value = (parseInt(quantityInput.value, 10) || 1) + 1;
        normalizeQuantity();
      });
    }

    quantityInput.addEventListener('input', normalizeQuantity);
    quantityInput.addEventListener('change', normalizeQuantity);
    quantityInput.addEventListener('blur', normalizeQuantity);
  }

  function setupMediaGallery() {
    var gallery = $('[data-sijl-gallery]');
    var scroller = $('[data-sijl-media-scroller]');

    if (!gallery || !scroller) return;

    var controls = $$('.sijl-gallery-dot, .sijl-gallery-thumb');
    var items = $$('.sijl-media-item');

    function setActive(index) {
      controls.forEach(function (control) {
        control.classList.toggle('active', String(control.dataset.mediaTarget) === String(index));
      });
    }

    controls.forEach(function (control) {
      control.addEventListener('click', function () {
        var target = gallery.querySelector('.sijl-media-item[data-media-index="' + control.dataset.mediaTarget + '"]');
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        setActive(control.dataset.mediaTarget);
      });
    });

    var ticking = false;

    scroller.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(function () {
        var scrollerRect = scroller.getBoundingClientRect();
        var closestItem = null;
        var closestDistance = Infinity;

        items.forEach(function (item) {
          var itemRect = item.getBoundingClientRect();
          var distance = Math.abs(itemRect.left - scrollerRect.left);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestItem = item;
          }
        });

        if (closestItem) setActive(closestItem.dataset.mediaIndex);
        ticking = false;
      });
    }, { passive: true });
  }

  function sijlCartNotifyAndOpen(payload, qtyAdded, fallback) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: payload,
        sourceId: 'sijl-buybox',
        data: { source: 'product-form-component', itemCount: qtyAdded || 1 }
      }
    }));

    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    } else if (typeof fallback === 'function') {
      fallback();
    }
  }

  function setupAjaxCart() {
    var atcButton = $('#sijl-main-atc');
    var form = atcButton ? atcButton.closest('form') : null;

    if (!atcButton || !form || form.dataset.sijlAjaxAttached === 'true') return;

    form.dataset.sijlAjaxAttached = 'true';

    form.addEventListener('submit', function (event) {
      var submitter = event.submitter || document.activeElement;
      if (submitter !== atcButton) return;
      if (event.defaultPrevented) return;

      event.preventDefault();

      if (!currentVariant || !currentVariant.available || atcButton.disabled) return;

      setDisabled(atcButton, true);
      atcButton.classList.remove('has-error');
      atcButton.classList.add('is-loading');
      atcButton.textContent = 'Naar winkelwagen...';

      fetch(getRoute('cart/add.js'), {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (payload) {
            if (!response.ok) throw new Error(payload.description || payload.message || 'Toevoegen mislukt');
            return payload;
          });
        })
        .then(function (payload) {
          atcButton.textContent = 'Toegevoegd!';
          sijlCartNotifyAndOpen(payload, getCurrentQuantity(), function () {
            window.location.href = getRoute('cart');
          });
          window.setTimeout(function () { renderAtcButton(currentVariant); }, 1200);
        })
        .catch(function (error) {
          atcButton.classList.remove('is-loading');
          atcButton.classList.add('has-error');
          atcButton.textContent = error.message || 'Fout bij toevoegen';
          window.setTimeout(function () { renderAtcButton(currentVariant); }, 2500);
        });
    });
  }

  function setupReadMore() {
    var descText = $('#sijl-desc-text');
    var readMoreBtn = $('#sijl-read-more-btn');
    var fade = $('#sijl-desc-fade');

    if (!descText || !readMoreBtn) return;

    if (descText.scrollHeight <= descText.clientHeight) {
      readMoreBtn.hidden = true;
      if (fade) fade.hidden = true;
    }

    readMoreBtn.addEventListener('click', function (event) {
      event.preventDefault();
      var isExpanded = descText.classList.toggle('expanded');
      readMoreBtn.textContent = isExpanded ? 'Lees minder' : 'Lees meer';
      if (fade) fade.hidden = isExpanded;
    });
  }

  function getConfiguredShippingDays() {
    return String(SHIPPING_DAYS_SETTING)
      .split(',')
      .map(function (day) { return parseInt(day.trim(), 10); })
      .filter(function (day) { return day >= 0 && day <= 6; });
  }

  function getNextShippingDate(date) {
    var shippingDays = getConfiguredShippingDays();
    if (!shippingDays.length) return date;

    for (var offset = 1; offset <= 14; offset++) {
      var candidate = new Date(date);
      candidate.setDate(date.getDate() + offset);
      if (shippingDays.indexOf(candidate.getDay()) !== -1) return candidate;
    }
    return date;
  }

  function getNextBusinessDay(date) {
    var next = new Date(date);
    next.setDate(date.getDate() + 1);
    while (next.getDay() === 0 || next.getDay() === 6) {
      next.setDate(next.getDate() + 1);
    }
    return next;
  }

  function setupShipmentDate() {
    var el = $('#sijl-dynamic-date');
    var uspDate = $('#sijl-usp-ship-date');

    var shipDate = SHIPPING_MODE === 'coffee'
      ? getNextShippingDate(new Date())
      : getNextBusinessDay(new Date());

    var formattedDate = shipDate.toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'long' });

    if (el) {
      el.innerHTML = SHIPPING_MODE === 'coffee'
        ? 'Uiterlijk <strong>' + formattedDate + '</strong> verzonden via DHL'
        : 'Eerstvolgende werkdag (<strong>' + formattedDate + '</strong>) verzonden';
    }

    if (uspDate) uspDate.textContent = '(' + formattedDate + ')';
  }


  function setupCoffeeCounter() {
    var counterEl = $('#sijl-coffee-counter');
    if (!counterEl || !MONTHLY_COFFEE_AVERAGE) return;

    var today = new Date();
    var startOfYear = new Date(today.getFullYear(), 0, 1);
    var daysPassed = Math.max(0, Math.floor((today - startOfYear) / 86400000));
    var totalCoffeesServed = Math.floor(daysPassed * (MONTHLY_COFFEE_AVERAGE / 30.4));

    counterEl.textContent = totalCoffeesServed.toLocaleString('nl-NL');
  }

  ready(function initSijlBuyBox() {
    setupMediaGallery();
    setupVariantSelector();
    setupQuantitySelector();
    setupAjaxCart();
    setupReadMore();
    setupShipmentDate();
    setupCoffeeCounter();
    formatStaticPrices();
    syncVariantState(currentVariant);
  });
})();
